<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2026-05-19 10:00:00
 * @Description  : 委托管控参数查看弹窗（只读）
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-05-19 09:57:16
 * @FilePath     : \ src\views\platform\ICPS\internetSales\supplyManagement\preparatoryCommission\components\ControlParam.vue
-->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1040px"
    :close-on-click-modal="false"
    @open="handleOpen"
  >
    <span slot="title" class="dialog-title">管控参数查看</span>
    <div class="control-container">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
        }"
      >
        <el-table-column label="委托类型" width="180" prop="type" />
        <!-- 第一级管控 -->
        <el-table-column label="第一级管控（任一突破即升级）" width="260">
          <template slot-scope="scope">
            <div class="param-group">
              <div class="param-item">
                <label>单次审批供应时长 ≤</label>
                <span>{{ scope.row.level1.time }}</span>
                <span>天</span>
              </div>
              <div class="param-item">
                <label>单次审批供应量 ≤</label>
                <span>{{ scope.row.level1.volume }}</span>
                <span>m³</span>
              </div>
              <div class="param-item">
                <label>供应次数 ≤</label>
                <span>{{ scope.row.level1.count }}</span>
                <span>次</span>
              </div>
              <div class="param-item">
                <label>委托累计总量 ≤</label>
                <span>{{ scope.row.level1.totalVolume }}</span>
                <span>m³</span>
              </div>
              <div class="param-item">
                <label>累计供应时长 ≤</label>
                <span>{{ scope.row.level1.totalTime }}</span>
                <span>天</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 第二级管控 -->
        <el-table-column label="第二级管控（任一突破即升级）" width="260">
          <template slot-scope="scope">
            <div class="param-group">
              <div class="param-item">
                <label>单次审批供应时长 ≤</label>
                <span>{{ scope.row.level2.time }}</span>
                <span>天</span>
              </div>
              <div class="param-item">
                <label>单次审批供应量 ≤</label>
                <span>{{ scope.row.level2.volume }}</span>
                <span>m³</span>
              </div>
              <div class="param-item">
                <label>供应次数 ≤</label>
                <span>{{ scope.row.level2.count }}</span>
                <span>次</span>
              </div>
              <div class="param-item">
                <label>委托累计总量 ≤</label>
                <span>{{ scope.row.level2.totalVolume }}</span>
                <span>m³</span>
              </div>
              <div class="param-item">
                <label>累计供应时长 ≤</label>
                <span>{{ scope.row.level2.totalTime }}</span>
                <span>天</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 第三级管控 -->
        <el-table-column label="第三级管控" width="260">
          <template slot-scope="scope">
            <div class="param-group">
              <div class="param-item">
                <label>单次审批供应时长 ≤</label>
                <span>{{ scope.row.level3.time }}</span>
                <span>天</span>
              </div>
              <div class="param-item">
                <label>单次审批供应量 ≤</label>
                <span>{{ scope.row.level3.volume }}</span>
                <span>m³</span>
              </div>
              <div class="param-item">
                <label>供应次数 ≤</label>
                <span>{{ scope.row.level3.count }}</span>
                <span>次</span>
              </div>
              <div class="param-item">
                <label>委托累计总量 ≤</label>
                <span>{{ scope.row.level3.totalVolume }}</span>
                <span>m³</span>
              </div>
              <div class="param-item">
                <label>累计供应时长 ≤</label>
                <span>{{ scope.row.level3.totalTime }}</span>
                <span>天</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 预警参数设置（只读） -->
      <div class="warning-section">
        <h4>预警参数设置</h4>
        <el-form :model="warningForm" label-width="180px" size="small">
          <el-form-item label="累计供应总量比例 ≥">
            <span>{{ warningForm.cumulativeRatio }}%</span>
            <span style="margin-left: 10px; font-size: 12px">
              预警（累计供应总量比例=实际产生累计供应量/委托量）
            </span>
          </el-form-item>
          <el-form-item label="委托期临界值预警 ≤">
            <span>{{ warningForm.deadlineDays }}天</span>
            <span style="margin-left: 10px; font-size: 12px">
              预警（委托期临界值预警=委托期截至时间-定时任务时间）
            </span>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryContrlParam } from "@/api/internetSales/supplyManagement.js";

export default {
  name: "ControlParamDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 必须包含 companyId 和 delegationTypeId
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      warningForm: {
        cumulativeRatio: 0,
        deadlineDays: 0,
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    handleOpen() {
      // 参数校验
      if (!this.rowData.companyId || !this.rowData.delegationTypeId) {
        this.$message.error("缺少公司ID或委托类型ID，无法查询管控参数");
        this.tableData = [];
        this.warningForm = { cumulativeRatio: 0, deadlineDays: 0 };
        return;
      }

      const params = {
        companyId: this.rowData.companyId,
        delegationTypeId: this.rowData.delegationTypeId,
      };

      // 不使用 try-catch，用 then 的两个回调处理错误
      queryContrlParam(params).then(
        (res) => {
          if (res.code === 1001 && res.data) {
            // 处理预警参数
            const qwWarning = res.data.qwWarning || {};
            this.warningForm = {
              cumulativeRatio: qwWarning.cumulativeSupplyRatio ?? 0,
              deadlineDays: qwWarning.warningDays ?? 0,
            };

            // 处理 qwParam，按委托类型分组（实际只有一条，但通用）
            const qwParamList = res.data.qwParam || [];
            if (qwParamList.length === 0) {
              this.tableData = [];
              return;
            }

            const groupMap = new Map();
            qwParamList.forEach((item) => {
              const typeId = item.delegationTypeId;
              if (!groupMap.has(typeId)) {
                groupMap.set(typeId, {
                  type: item.delegationType,
                  delegationTypeId: typeId,
                  level1: { time: 0, volume: 0, count: 0, totalVolume: 0, totalTime: 0 },
                  level2: { time: 0, volume: 0, count: 0, totalVolume: 0, totalTime: 0 },
                  level3: { time: 0, volume: 0, count: 0, totalVolume: 0, totalTime: 0 },
                });
              }
              const group = groupMap.get(typeId);
              const level = item.controlLevel;
              const levelData = {
                time: item.singleDuration ?? 0,
                volume: item.singleSupply ?? 0,
                count: item.supplyFrequency ?? 0,
                totalVolume: item.cumulativeSupply ?? 0,
                totalTime: item.cumulativeDuration ?? 0,
              };
              if (level === 1) group.level1 = levelData;
              else if (level === 2) group.level2 = levelData;
              else if (level === 3) group.level3 = levelData;
            });

            this.tableData = Array.from(groupMap.values());
          } else {
            this.$message.error(res.codeMsg || "查询管控参数失败");
            this.tableData = [];
            this.warningForm = { cumulativeRatio: 0, deadlineDays: 0 };
          }
        },
        (error) => {
          this.$message.error("查询管控参数失败：" + (error.message || "未知错误"));
          this.tableData = [];
          this.warningForm = { cumulativeRatio: 0, deadlineDays: 0 };
        }
      );
    },

    closeDialog() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-title {
  font-size: 18px;
  font-weight: 500;
}

.control-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.param-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
}

.param-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.param-item label {
  white-space: nowrap;
  min-width: 100px;
}

.warning-section {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-top: 20px;

  h4 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 500;
  }
}
</style>